import { Agent } from 'src/types/agents.ts';
import { FC } from 'react';
import { AgixBotContent } from './AgixBotContent.tsx';
import { AgixBotFooter } from './AgixBotFooter.tsx';

interface ChatProps {
  agent: Agent;
}

export const Chat: FC<ChatProps> = ({ agent }) => {
  return (
    <div className="flex h-[500px] flex-col rounded-3xl bg-[#1A1C1E] p-6 md:h-[350px] xl:h-[500px]">
      <h2 className="mb-6 text-lg font-semibold">Chat</h2>
      <AgixBotContent />
      <AgixBotFooter />
    </div>
  );
};
